import React from 'react'
import classNames from 'classnames'

interface CardProps {
  className?: string
  variant?:
    | 'regular'
    | 'plum'
    | 'topPicks'
    | 'modal'
    | 'linkCollectionPrimary'
    | 'linkCollectionSecondary'
    | 'rounded'
}

const Card: React.FC<CardProps> = ({ variant, className, children, ...props }) => {
  return (
    <div className={classNames('Card', { [`Card__${variant}`]: variant }, className)} {...props}>
      {children}
    </div>
  )
}

export default Card
